// src/components/LandingPage/Header.tsx
import { useState } from "react";
import capgeminiLogo from "../../assets/capgemini.png";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { label: "Home", href: "#home" },
    { label: "Choose Your Quest", href: "#quests" },
    { label: "Innovation DNA", href: "#innovation-dna" },
    { label: "Innovation Journey", href: "#innovation-journey" }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-[rgba(255,255,255,0.95)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1)] z-50">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">

        {/* Logo */}
        <div className="w-[140px] sm:w-[180px] h-[36px] sm:h-[40px] shrink-0">
          <img src={capgeminiLogo} alt="Capgemini" className="h-8 sm:h-10 w-auto object-contain" />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-4 xl:gap-9">
          {links.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-[#364153] text-sm xl:text-base font-normal px-2 hover:text-[#0058AB] transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Desktop Auth */}
        <div className="hidden lg:flex items-center gap-3 xl:gap-5 shrink-0">
          <button
            onClick={() => navigate("/login")}
            className="px-4 xl:px-5 py-2 border border-[#0058AB] rounded-full text-[#0058AB] text-sm font-medium hover:bg-[#0058AB] hover:text-white transition-colors"
          >
            Login
          </button>
          <button
            onClick={() => navigate("/signup")}
            className="bg-[#0058AB] px-4 xl:px-5 py-2 rounded-full text-white text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Sign Up
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden p-2 text-[#1d365a]"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
            )}
          </svg>
        </button>

      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-top border-gray-100 px-4 py-4 flex flex-col gap-3">
          {links.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              className="text-[#364153] text-sm font-normal py-2 hover:text-[#0058AB] transition-colors"
            >
              {item.label}
            </a>
          ))}

          <div className="flex gap-3 pt-2">
            <button
              onClick={() => navigate("/login")}
              className="flex-1 py-2 border border-[#1d365a] rounded-full text-[#1d365a] text-sm font-medium hover:bg-[#1d365a] hover:text-white transition-colors"
            >
              Login
            </button>

            <button
              onClick={() => navigate("/signup")}
              className="flex-1 py-2 rounded-full text-white text-sm font-medium"
              style={{ backgroundImage: "linear-gradient(90deg, rgb(29, 54, 90) 0%, rgb(0, 88, 171) 100%)" }}
            >
              Sign Up
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
